import React from "react";
import PropTypes from "prop-types";

import withStyles from '@mui/styles/withStyles';

import Fichier from 'components/Shared/Fichier';
import FournisseurGestionAutocomplete from 'components/Shared/FournisseurGestionAutocomplete';
import QualificationComponent from './QualificationComponent';
import QualificationAccordionSummary from './QualificationAccordionSummary';

import { ReclamationQualificationDetailType } from 'constants.js';
import { ReclamationQualificationDetailCodes } from 'constants.js';
import { GarantieType } from 'constants.js';
import { PerimetresSAV } from 'constants.js';

import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import Button from '@mui/material/Button';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import Stack from '@mui/material/Stack';

const question = "Quel est le fournisseur de l'article ?";

const styles = theme => ({
    row: {
        flexBasis: '100%',
        marginBottom: '10px'
    },

    formControl: {
        margin: theme.spacing(1),
        width: '100%'
    },

    formLabel: {
        marginBottom: theme.spacing(1)
    },
});


class FicheRetourFournisseur extends QualificationComponent {

    constructor(props) {
        super(props);

        this.state = {
            ...this.state,
            fournisseur: null,
        };

        this.generableCodes = [
            ReclamationQualificationDetailCodes.Fournisseur
        ];
    }

    componentDidMount() {
        const { name } = this.props;
        const { position, toAdd, toDelete } = this.getQualificationData(this.state);

        this.props.onChange(name, position, toAdd, toDelete, "Mount");
    }

    getQualificationData(newState) {
        // Préparation des codes à supprimer (tous les codes générables)
        let toDelete = [...this.generableCodes];

        if (!newState.fournisseur || newState.fournisseur.id === 0) {
            return {
                name: newState.name,
                position: this.props.position,
                toAdd: null,
                toDelete: toDelete
            };
        }

        let toAdd = [];

        toAdd.push({
            position: 0,
            code: ReclamationQualificationDetailCodes.Fournisseur,
            type: ReclamationQualificationDetailType.FournisseurId,
            libelle: question,
            valeurInteger: newState.fournisseur.id,
            valeurString: newState.fournisseur.code + " - " + newState.fournisseur.nom,
            valeurObject: newState.fournisseur
        });
        toDelete = toDelete.filter(x => x !== ReclamationQualificationDetailCodes.Fournisseur)

        return {
            name: newState.name,
            position: this.props.position,
            toAdd: toAdd,
            toDelete: toDelete
        }
    }

    render() {
        const { classes, garantie, name, clientId, codeDepot, onOpenSendMail } = this.props;
        const { fournisseur } = this.state;

        let fichierId = 0;
        if (fournisseur && fournisseur.conditionsSAV) {

            let conditionSAV = fournisseur.conditionsSAV.find(x => x.garantieType === garantie && x.perimetre === PerimetresSAV.Societe)

            if (conditionSAV && conditionSAV.detail && conditionSAV.detail.ficheRetourFournisseur) {
                fichierId = conditionSAV.detail.ficheRetourFournisseur.id;
            }
        }

        return (

            <Accordion id={name} defaultExpanded={true} elevation={3}>

                <QualificationAccordionSummary title="Sélection du fournisseur" />

                <AccordionDetails style={{ display: 'flex', flexDirection: 'column' }}>

                    <FormControl required className={classes.formControl}>

                        <FormLabel className={classes.formLabel}>{question}</FormLabel>

                        <FournisseurGestionAutocomplete
                            onChange={fournisseur => {
                                this.handleChange({
                                    target: {
                                        name: "fournisseur",
                                        value: fournisseur
                                    }
                                });
                            }}
                            withConditionsSAVGenerales
                            required
                            clientId={clientId}
                            codeDepot={codeDepot}
                            autoriseSAV
                        />

                    </FormControl>

                    <Stack direction="row"
                        justifyContent="space-between"
                        alignItems="center"
                    >

                        {/* Fichier */}
                        {fichierId !== 0 && (
                            <Stack direction="column">
                                <p>Veuillez télécharger la fiche de retour fournisseur.</p>
                                <Fichier fichierId={fichierId} />
                            </Stack>
                        )}

                        {/* Fichier manquant */}
                        {fournisseur && !fichierId && (
                            <p>Ce fournisseur n'a pas de fiche retour spécifique</p>
                        )}

                        {fournisseur &&
                            <Stack direction='column'>
                                <p>
                                    Si vous indentifiez une anomalie dans ce document conditions fournisseurs,<br />
                                    ou si certaines choses ont changé, n'hésitez pas à nous informer:
                                </p>
                                <Button
                                    color="primary"
                                    variant="contained"
                                    onClick={() => onOpenSendMail(fournisseur)}
                                >
                                    Envoyer un mail à info-sav@foussier.fr
                                </Button>
                            </Stack>
                        }

                    </Stack>

                </AccordionDetails>
            </Accordion >
        );
    }

}


FicheRetourFournisseur.propTypes = {
    name: PropTypes.string.isRequired,
    garantie: PropTypes.number,
    clientId: PropTypes.number,
    codeDepot: PropTypes.string,
};

FicheRetourFournisseur.defaultProps = {
    garantie: GarantieType.SousGarantieApresUtilisation,
};

export default withStyles(styles)(FicheRetourFournisseur);